<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Listado de Precios</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-6">
              <router-link class="btn btn-sm btn-success" :to="{ name: 'cat-lista_precios-nueva', params: {} }">
                <i class="fa fa-plus"></i>
                Nueva Lista
              </router-link>
              <a class href="#"></a>
              <a v-if="mostrarRefresh" class="btn btn-sm btn-info" @click="refreshData" href="#">Refresh</a>
            </div>
            <div class="col-sm-6">
              <form @submit="filterData" action="#" class="form-inline justify-content-sm-end">
                <input class="form-control form-control-sm rounded bright" placeholder="Search" v-model="searchtext"
                  type="text" />
                <select class="form-control form-control-sm rounded bright" v-model="filterActivo" @click="filterData">
                  <option value="null">Todos</option>
                  <option value="true">Activo</option>
                  <option value="false">Inactivo</option>
                </select>
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="submit">
                    <i class="fa fa-search"></i>
                  </button>
                  <button class="btn btn-link btn-sm" type="button" v-on:click="clearFilterData">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <!-------------------- END - Controles arriba de tabla-------------------->
        <div class="table-responsive">
          <!-------------------- Tabla de Resultados -------------------->
          <table class="table table-hover">
            <thead>
              <tr>
                <th>ID</th>
                <th>Lista de Precio</th>
                <th class="text-center">Estatus</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="current in data.results" v-bind:key="current.id" @click="rowClick(current)">
                <td>{{ current.id }}</td>
                <td>{{ current.nombre }}</td>
                <td class="text-center">
                  <div v-if="current.estatus" class="status-pill green" data-title="Activo" data-toggle="tooltip"></div>
                  <div v-if="!current.estatus" class="status-pill red" data-title="Inactivo" data-toggle="tooltip">
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
        </div>
        <PaginationComponent :currentPage="currentPage" :data="data" @pagechanged="onPageChange" />
      </div>
    </div>
  </div>
</template>

<script>
import ListaPrecioFormComponent from "@/components/cat/lista_precios/ListaPrecioFormComponent";
import PaginationComponent from "@/components/utils/PaginationComponent";
import ListaPreciosService from "@/services/catalogos/ListaPreciosService";

export default {
  components: {
    PaginationComponent,
    ListaPrecioFormComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filterActivo: null,
      data: [],
      selected: {},
    };
  },
  mounted() {
    this.refreshData();
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
        estatus: this.filterActivo,
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        estatus: this.filterActivo,
      });
    },
    clearFilterData() {
      this.searchtext = "";
      this.filterActivo = null;
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        estatus: this.filterActivo,
      });
    },
    hide: function () {
      this.$data.destroy();
    },
    onRefreshData() { },
    refreshData(params) {
      let self = this;
      ListaPreciosService.fetch(params).then((res) => {
        self.data = res.data;
      });
    },
    mostrarModalListaPrecioForm() {
      let self = this;
    },
    abrirModalListaPrecio(current) {
      let self = this;
      // self.selected =
      this.$store.dispatch("listaprecios/set", current);
      /*
            self.selected = current;
            Vue.nextTick(function () {
                })
            self.mostrarModalListaPrecioForm();
            */
      $("#modalFormListaPrecio").modal();
    },
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "cat-lista_precios-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "cat-lista_precios-editar",
          params: { id: current.id },
        });
      }
    },
  },
};
</script>
